import React from "react";
import PropTypes from "prop-types";

// Components
import { ChartComponent } from "src/components/chart_component";
import { GridRow, GridColumn } from "src/components/grid";
import {
  StartRenderTimeTrackComponent,
  FinishRenderTimeTrackComponent
} from "src/components/analytics";
import { LoadingComponent } from "src/components/loading_component";

import { analyticsEventNames } from "src/constants";
import { loadStates as _loadStates } from "src/constants/load_states";

/**
 * Render a chart.js chart showing wound trends over time grouped by wound progress
 */
export class WoundsOptimizedProgressChartComponent extends React.PureComponent {
  static propTypes = {
    chartDefinition: PropTypes.object.isRequired,
    loadStates: PropTypes.array.isRequired
  };

  render() {
    const { loadStates } = this.props;
    if (!loadStates || !loadStates.length || loadStates.some(val => !val)) {
      return (
        <StartRenderTimeTrackComponent
          eventName={analyticsEventNames.renderOptimizedWoundsChart}
        >
          <LoadingComponent />
        </StartRenderTimeTrackComponent>
      );
    } else if (loadStates.some(val => val === _loadStates.loading)) {
      return (
        <StartRenderTimeTrackComponent
          eventName={analyticsEventNames.renderOptimizedWoundsChart}
        >
          <LoadingComponent />
        </StartRenderTimeTrackComponent>
      );
    } else if (loadStates.some(val => val === _loadStates.error)) {
      return (
        <FinishRenderTimeTrackComponent
          eventName={analyticsEventNames.renderOptimizedWoundsChart}
          error={true}
        >
          <LoadingComponent />;
        </FinishRenderTimeTrackComponent>
      );
    } else {
      return (
        <FinishRenderTimeTrackComponent
          eventName={analyticsEventNames.renderOptimizedWoundsChart}
        >
          <GridRow className="chart-container">
            <GridColumn xs="12">
              <div className="line-chart">
                <ChartComponent
                  chartDefinition={this.props.chartDefinition}
                  width={750}
                  height={300}
                />
              </div>
            </GridColumn>
          </GridRow>
        </FinishRenderTimeTrackComponent>
      );
    }
  }
}
